// removed by extract-text-webpack-plugin
module.exports = {"progress":"_2VpMns-PSngHxySFHx9lW7","spin":"_12UIdAEG4fCFFu6T7oOnKz"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/v2/atoms/Loading/style.module.css
// module id = 692
// module chunks = 38